export var CalculationMethodInclude = {
    activityDataSourceMappings: true,
    type: true,
    mainUnit: true,
};
//# sourceMappingURL=CalculationMethod.js.map